/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import propertiesSectionData from "../data/propertiesSectionData";
import { useState } from "react";

export default function LandDetailes() {
    const { t } = useTranslation();
    const { id } = useParams();
    UseScrollAnimation();

    const property = propertiesSectionData.find((item) => item.id === id);
    const [mainImage, setMainImage] = useState(property?.mainImage || "default-image.png");
    const [showLightbox, setShowLightbox] = useState(false);

    if (!property) {
        return <div>Property not found.</div>;
    }

    return (
        <>
            <section
                className="blog-landing"
                style={{
                    backgroundImage: `url(${property?.mainImage || "default-image.png"})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t(`${property.placeName}`)}</div>
                    </div>
                </div>
            </section>

            {/* Property Details Section */}
            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="w-full flex flex-col gap-[20px]">
                        {/* Main Image */}
                        <div
                            className="w-full cursor-pointer"
                            onClick={() => setShowLightbox(true)}
                        >
                            <img
                                className="w-full h-[450px] object-cover rounded-[4px]"
                                src={mainImage}
                                alt="Main Property"
                            />
                        </div>

                        {/* Thumbnail Images */}
                        <div className="flex items-center gap-[10px] overflow-x-auto no-scrollbar">
                            {property.subImage.map((el, index) => (
                                <img
                                    key={index}
                                    src={el}
                                    alt={`Thumbnail ${index}`}
                                    className="w-[100px] h-[100px] rounded-[4px] cursor-pointer border-2 border-transparent hover:border-[#132A40] transition object-cover"
                                    onClick={() => {
                                        setMainImage(el);
                                        setShowLightbox(true);
                                    }}
                                />
                            ))}
                        </div>

                        {/* Lightbox Popup */}
                        {showLightbox && (
                            <div
                                className="fixed inset-0 bg-black/80 z-[100] flex items-center justify-center p-4"
                                onClick={() => setShowLightbox(false)}
                            >
                                <div
                                    className="relative w-full"
                                    onClick={e => e.stopPropagation()}
                                >
                                    {/* Close Button */}
                                    <button
                                        className="absolute -top-10 right-0 text-white text-3xl p-2 hover:text-gray-300 transition"
                                        onClick={() => setShowLightbox(false)}
                                    >
                                        ×
                                    </button>

                                    {/* Main Lightbox Image */}
                                    <img
                                        src={mainImage}
                                        alt="Lightbox view"
                                        className="h-60-vh w-full h-[85vh] object-contain rounded-[4px]"
                                    />

                                    {/* Navigation Arrows */}
                                    <button
                                        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white text-4xl w-12 h-12 rounded-full flex items-center justify-center transition disabled:opacity-30 disabled:hover:bg-white/20"
                                        onClick={() => {
                                            const currentIndex = property.subImage.indexOf(mainImage);
                                            if (currentIndex > 0) {
                                                setMainImage(property.subImage[currentIndex - 1]);
                                            }
                                        }}
                                        disabled={property.subImage.indexOf(mainImage) === 0}
                                    >
                                        ←
                                    </button>
                                    <button
                                        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white text-4xl w-12 h-12 rounded-full flex items-center justify-center transition disabled:opacity-30 disabled:hover:bg-white/20"
                                        onClick={() => {
                                            const currentIndex = property.subImage.indexOf(mainImage);
                                            if (currentIndex < property.subImage.length - 1) {
                                                setMainImage(property.subImage[currentIndex + 1]);
                                            }
                                        }}
                                        disabled={property.subImage.indexOf(mainImage) === property.subImage.length - 1}
                                    >
                                        →
                                    </button>

                                    {/* Thumbnail Navigation */}
                                    <div className="flex justify-center gap-2 mt-4 overflow-x-auto">
                                        {property.subImage.map((el, index) => (
                                            <img
                                                key={index}
                                                src={el}
                                                alt={`Thumbnail ${index}`}
                                                className={`w-16 h-16 rounded-[4px] cursor-pointer border-2 ${mainImage === el ? 'border-[#132A40]' : 'border-transparent'
                                                    } object-cover`}
                                                onClick={() => setMainImage(el)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="">
                        <div className="py-[20px]">
                            <div className="js-scroll fade-top flex flex-col gap-[3px]">
                                <div className="text-[30px] font-bold text-[#0B2C3D] capitalize">{t(`${property.city}`)} - {t(`${property.countries}`)}</div>
                                <img className="h-[3px]" src={require("../../assets/icons/line-text.svg").default} alt="" />
                            </div>
                            <div className="text-[30px] font-bold text-[#0B2C3D] capitalize">{t(`${property.price}`)}</div>
                            <ul className="list-disc pl-6 mt-4">
                                {/* <li>{t("Statues:")} {t(`${property.statues}`)}</li> */}
                                <li>{t("Completion Date")} : {t(`${property.completionDate}`)}</li>
                                <li>{t("Place Name")} : {t(`${property.placeName}`)}</li>
                                <li>{t("Area")} : {t(`${property.area}`)}</li>
                                <li>{t("Bedroom")} : {t(`${property.bedroom}`)}</li>
                            </ul>
                        </div>

                        <div className="w-100 w-full flex flex-col gap-[10px]">
                            <div className="text-[24px] text-[#0B2C3D] font-bold">{t("Approximate Locations")}</div>
                            <div className="flex flex-wrap">
                                {property.approximateLocations.map((location, index) => (
                                    <div key={index} className="w-100 w-[25%] h-[200px] border-[1px] border-[#eee] p-[20px] flex flex-col gap-[7px] items-center justify-center text-center">
                                        <div className="flex items-center justify-center shadow rounded-full w-[60px] h-[60px]">
                                            <img className="w-[28px] h-[28px]" src={require("../../assets/icons/approximate.svg").default} alt="" />
                                        </div>
                                        <div className="font-bold">{t(`${location}`)}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="py-[20px]">
                            <div className="border-[1px] border-[#eee] w-fit py-[7px] px-[20px] text-xl font-semibold mt-4">{t("Overview")}</div>
                            <div className="border-[1px] border-[#eee] p-[15px]">
                                {property.overview.map((overview, index) => (
                                    <div key={index} className="mb-4 flex flex-col gap-[7px]">
                                        <h4 className="text-[22px] font-bold">{t(`${overview.title}`)}</h4>
                                        <p className="text-[#0B2C3D] leading-[1.1]">{t(`${overview.details}`)}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="py-[20px]">
                            <div className="border-[1px] border-[#eee] w-fit py-[7px] px-[20px] text-xl font-semibold mt-4">{t("Location")}</div>
                            <div className="">
                                <iframe
                                    src={property.locationFrameٍٍ}
                                    width="600"
                                    height="450"
                                    style={{ border: 0 }}
                                    allowFullScreen
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    className="w-[100%] max-h-[500px]"
                                />
                            </div>
                            <div className="flex items-center justify-center my-[15px]">
                                <Link to={property.locationLink} className="flex items-center gap-[7px] bg-[#0B2C3D] w-fit capitalize py-[8px] px-[30px] rounded-[4px] font-bold text-white">
                                    {t("Visit location")}
                                    <img
                                        src={require("../../assets/icons/arrow-button.svg").default}
                                        alt=""
                                        className="w-[15px] h-[15px]"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container flex flex-col gap-[20px] p-[30px] shadow-[0px_0px_10px_rgba(0,0,0,0.2)] rounded-[8px]">
                    <div className="font-bold text-[25px] text-[#0B2C3D]">{t("Request Information")}</div>
                    <form action="https://ligasos.co/send_request.php" method="POST">
                        <div className="flex flex-col gap-[15px]">
                            <div className="f-col flex gap-[20px]">
                                <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("First Name")}
                                        </label>
                                        <input
                                            name="first_name"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                            type="text"
                                            placeholder={t("First Name")}
                                            required
                                        />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("Email")}
                                        </label>
                                        <input
                                            name="email"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                            type="email"
                                            placeholder={t("Email")}
                                            required
                                        />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("Project Name")}
                                        </label>
                                        <input
                                            name="project_name"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                            type="text"
                                            value={property.placeName}
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="w-100 w-[48%] flex flex-col gap-[10px]">
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("Last Name")}
                                        </label>
                                        <input
                                            name="last_name"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                            type="text"
                                            placeholder={t("Last Name")}
                                            required
                                        />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("Phone Number")}
                                        </label>
                                        <input
                                            name="phone"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px]"
                                            type="tel"
                                            placeholder={t("Phone Number")}
                                            required
                                        />
                                    </div>
                                    <div className="flex flex-col gap-[7px]">
                                        <label className="js-scroll fade-top font-bold text-[22px] text-[#132A40] capitalize">
                                            {t("Countries")}
                                        </label>
                                        <input
                                            name="country"
                                            className="js-scroll fade-btm border-l-8 border-[#132A40] outline-none bg-[rgb(19_42_64/14%)] px-[15px] py-[8px] capitalize"
                                            type="text"
                                            value={property.countries}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="js-scroll fade-btm w-fit bg-[#132A40] text-white px-[40px] py-[8px] rounded font-bold capitalize"
                            >
                                {t("Send")}
                            </button>
                        </div>
                    </form>
                </div>
            </section>
        </>
    );
}